import { Auth } from '@aws-amplify/auth';
import { useQuery } from 'react-query';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import AppLoader from './basic/AppLoader';
import { useAlerts } from '../hooks/alerts-hooks';

const Logout = () => {
  const history = useHistory();
  const { alertSuccess, alertError } = useAlerts();
  const { isLoading, refetch: signOut } = useQuery([ 'user' ],
    () => {
      return Auth.signOut();
    },
    {
      enabled: false,
    });

  useEffect(() => {
    signOut()
      .then(() => {
        alertSuccess('Successfully signed out');
        alertSuccess('See you back soon :)');
      }).then(() => {
        history.push('/login');
      }).catch((err) => {
        alertError('Could not sign out. Please try again');
        alertError(err);
      });
  }, [ signOut, history ]);

  if (isLoading) { return <AppLoader />; }

  return null;
};

export default Logout;
